<div class="flex min-h-0 flex-1 gap-6 max-lg:flex-col max-lg:gap-3">
  <lib-waiting-list
    [students]="store.waitingStudents()"
    [highlightedIds]="store.highlightedIds()"
    [hasError]="!!store.loadOpenPickupsError()"
    [isLoading]="store.loadOpenPickupsLoading()"
    (retry)="retryWaiting()"
    class="min-w-0 flex-1"
  />
  <lib-completed-list
    [students]="store.completedStudents()"
    [hasError]="!!store.loadRecentCompletedError()"
    [isLoading]="store.loadRecentCompletedLoading()"
    (retry)="retryCompleted()"
    class="w-[400px] shrink-0 max-lg:w-full"
  />
</div>
